import React from 'react';
import { Image, Images } from 'theme/images';

import { SocialMediaLink, SocialMediaSection } from './styles';

export const socialMediaLinks = [
  {
    imageName: 'facebook',
    label: 'Naked Insurance on Facebook',
    url: Config.Shared.Links.SocialMedia.FACEBOOK_URL,
  },
  {
    imageName: 'instagram',
    label: 'Naked Insurance on Instagram',
    url: Config.Shared.Links.SocialMedia.INSTAGRAM_URL,
  },
  {
    imageName: 'twitter',
    label: 'Naked Insurance on X',
    url: Config.Shared.Links.SocialMedia.TWITTER_URL,
  },
  {
    imageName: 'linkedin',
    label: 'Naked Insurance on LinkedIn',
    url: Config.Shared.Links.SocialMedia.LINKEDIN_URL,
  },
  {
    imageName: 'tiktok',
    label: 'Naked Insurance on TikTok',
    url: Config.Shared.Links.SocialMedia.TIKTOK_URL,
  },
];

/**
 * `SocialMediaLinks` is a functional component that renders a section with social media links in the footer.
 * Clicking on a link opens it in a new tab.
 *
 */
export function SocialMediaLinks() {
  return (
    <SocialMediaSection about="Social links">
      {socialMediaLinks.map(({ imageName, url, label }) => (
        <SocialMediaLink
          key={imageName}
          href={url}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
        >
          <Image alt={label} src={Images[imageName]} loading="lazy" style={{ height: '32px' }} />
        </SocialMediaLink>
      ))}
    </SocialMediaSection>
  );
}
